import { Pipe, PipeTransform } from "@angular/core";
import { round } from "@modules/core/util/component-util";

interface Args {
	omitZero?: boolean;
	precision: number;
	exponentPrecision?: boolean;
	prefix?: boolean;
	notPrice?: boolean;
	cutZeroSuffix?: boolean;
	showPositivePrefix?: boolean;
}
@Pipe({
	name: "new_fiat_precision",
	standalone: false
})

// TODO FiatPrecisionPipe -> PrecisionPipe ?
export class FiatPrecisionPipe implements PipeTransform {
	protected defaultPrecision: number = 2;

	public transform(value: string | number, args?: Args): string {
		let amount: number = typeof value === "string" ? +value : value;
		if (args?.omitZero && amount === 0) {
			return "-";
		}

		if (args?.precision) {
			let rounded: string = this.roundValue(amount, args.precision, args.exponentPrecision);
			if (args.prefix) {
				if (amount < Math.pow(10, -args.precision)) {
					if (amount >= 0) {
						rounded = "< " + rounded.substring(0, rounded.length - 1) + "1";
					}
				} else if (!args.notPrice) {
					rounded = "~" + rounded;
				}
			}
			if (args.cutZeroSuffix) {
				let i = 0;
				// Leave at least 2 decimals
				while (rounded.lastIndexOf("0") === rounded.length - 1 && i++ < 2) {
					rounded = rounded.substr(0, rounded.length - 1);
				}
			}
			if (args.showPositivePrefix) {
				return "+" + rounded;
			}

			return rounded;
		}
		return round(amount, this.defaultPrecision);
	}

	protected roundValue = (amount: number, precision: number, exponent?: boolean): string => {
		if (exponent) {
			return "" + Math.trunc(+amount / Math.pow(10, precision)) * Math.pow(10, precision);
		}
		return round(amount, precision ? precision : this.defaultPrecision);
	};
}
